import { Component, inject, PLATFORM_ID, afterNextRender, Injector, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NowPlayingWidgetComponent } from "@components/now-playing-widget/now-playing-widget.component";
import { isPlatformBrowser } from '@angular/common';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, NowPlayingWidgetComponent],
	templateUrl: './app.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [],
})
export class AppComponent {
	private platformId = inject<Object>(PLATFORM_ID);
	private injector = inject(Injector);
	constructor() {
		// Load analytics after first paint/idle to keep it out of initial JS.
		afterNextRender(() => {
			const run = () =>
				import('@vercel/analytics')
					.then(m => m.inject?.())
					.catch(() => {});

			const w = window as unknown as {
				requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void;
			};
			if (typeof w.requestIdleCallback === 'function') {
				w.requestIdleCallback(run, { timeout: 5000 });
			} else {
				setTimeout(run, 1500);
			}
		}, { injector: this.injector });
	}
}
